/* eslint-disable max-len */

import { Header } from 'src/cms/Header/Header'
import { GiftSubscriptionBuy } from 'src/components/GiftSubscription/GiftSubscriptionBuy'
import { LinkToClaimSection } from 'src/components/GiftSubscription/LinkToClaimSection'
import { ImageTextContainer } from 'src/components/ImageTextContainer/ImageTextContainer'

import { BottomInfoSection } from './BottomInfoSection'
import styles from './GiftSubscription.module.scss'
import { MidInfoSection } from './MidInfoSection'
import { TopInfoSection } from './TopInfoSection'

import type { HeaderProps } from 'src/cms/Header/Header'
import type { SubscriptionPlan, SubscriptionPrice } from 'src/types/Subscription'

export interface GiftSubscriptionsBuyPageProps {
  plans: SubscriptionPlan[]
  prices: SubscriptionPrice[]
  title: string
}

export const GiftSubscriptionBuyPage = ({ plans, prices, title }: GiftSubscriptionsBuyPageProps) => {
  const subtitle =
    'Einfach für dich, eine Menge glücklicher Morgen und Wochenenden für den/die Beschenkte:n. Jeder unserer Kaffees ist einzigartig, direkt gehandelt, frisch in Berlin geröstet und kommt als ganze Bohne bequem nach Hause. Damit ist Dankbarkeit garantiert.'

  const header: HeaderProps = {
    type: 'page',
    title,
    category: null,
    header: {
      isSimple: true,
      showTitle: true,
      opacity: null,
      position: null,
      image: {
        id: 'd58b7251-b4b9-41fc-9bf4-945a8bf19e4a',
        filename: 'image',
        name: 'abo',
        alt: 'abo title',
        title: 'abo-title',
        caption: 'caption',
        width: 400,
        height: 300,
      },
    },
  }

  const imageTextContainerIntroText =
    'Mit dem Coffee Circle Geschenkabo schenkst du nicht nur richtig guten Kaffee, sondern hilfst auch, das Leben der Kaffeefarmer:innen und ihrer Familien zu verbessern. Denn 1 € pro Kilogramm Kaffee investieren wir in die Ursprungsländer, wo wir uns für sauberes Trinkwasser, Bildung und nachhaltigen Kaffeeanbau einsetzen.'

  return (
    <section className={styles.containerOverrides}>
      <Header {...header} />
      <TopInfoSection subtitle={subtitle} isBuyPage />
      <GiftSubscriptionBuy plans={plans} prices={prices} />
      <MidInfoSection />
      <ImageTextContainer
        title="Ein Geschenk, das allen Freude bringt"
        imageId="4cb2dc31-e149-4153-8058-59e1dd3266c7"
        imagePosition="left"
        intro={imageTextContainerIntroText}
        buttonText="Erfahre mehr zu unseren Projekten"
        buttonUrl="/de/e/projekte"
        buttonVariant="secondary"
      />
      <BottomInfoSection />
      <LinkToClaimSection />
    </section>
  )
}
